import { actionTextColor } from "../../utils/themeContrast";
import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { IoBagHandleOutline, IoCheckmark } from "react-icons/io5";
import { ThemeContext, LanguageContext } from "../../contexts/Context";
import { lightTint, readableText } from "../../utils/themeContrast";

const TakeAwayCheckBox = ({ index, lanIndex, isTakeAway, setTakeAway }) => {
  const theme = React.useContext(ThemeContext);
  const language = React.useContext(LanguageContext);
  const [selected, setSelected] = useState(Boolean(isTakeAway));
  useEffect(() => { setSelected(Boolean(isTakeAway)); }, [isTakeAway]);

  return <Wrapper>
    <Selector type="button" themeContext={theme} selected={selected} aria-pressed={selected}
      onClick={() => {
        const next = !selected;
        setSelected(next);
        setTakeAway(next, index);
      }}>
      <IoBagHandleOutline size={22} aria-hidden="true" />
      <Label>{language[lanIndex].takeAway}</Label>
      <Indicator themeContext={theme} selected={selected} aria-hidden="true">
        {selected && <IoCheckmark size={15} />}
      </Indicator>
    </Selector>
  </Wrapper>;
};
export default TakeAwayCheckBox;

const Wrapper = styled.div`
  margin: 20px 16px;
`;
const Selector = styled.button`
  width: 100%;
  min-height: 54px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 14px;
  border: 1px solid ${p => lightTint(p.themeContext.primaryColor, p.selected ? .4 : .2)};
  background: ${p => p.selected ? lightTint(p.themeContext.primaryColor, .07) : p.themeContext.backgroundColor};
  color: ${p => readableText(p.selected ? lightTint(p.themeContext.primaryColor, .07) : p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily};
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease;
  > svg { flex-shrink: 0; color: ${p => readableText(p.selected ? lightTint(p.themeContext.primaryColor, .07) : p.themeContext.backgroundColor, p.themeContext.primaryColor)}; }
  &:focus-visible { outline: 2px solid ${p => p.themeContext.primaryColor}; outline-offset: 3px; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;
const Label = styled.span`
  flex: 1;
  font-weight: 500;
`;
const Indicator = styled.span`
  width: 22px;
  height: 22px;
  box-sizing: border-box;
  border-radius: 50%;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border: 1px solid ${p => p.selected ? p.themeContext.primaryColor : lightTint(p.themeContext.primaryColor, .4)};
  background: ${p => p.selected ? p.themeContext.primaryColor : p.themeContext.backgroundColor};
  color: ${p => actionTextColor(p.themeContext)};
`;
